/**
 * Authentication element. when auth redirect to /
 */

import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isAuthorized, clearAuthentication } from './Authentication';
import AppContext from 'context/Context';
import _ from 'lodash';

const AuthenticationElement = () => {
  const from = useLocation().pathname;
  const {
    config: { corp }
  } = useContext(AppContext);

  //Logout clear authentication
  if (_.endsWith(from, 'logout')) {
    clearAuthentication(corp);
  }

  const is_auth = isAuthorized(corp);
  if (is_auth) {
    if (_.endsWith(from, 'reset-password')) {
      return <Outlet />;
    } else {
      return <Navigate to={process.env.REACT_APP_HOME} />;
    }
  } else {
    if (_.endsWith(from, 'reset-password')) {
      return <Navigate to={process.env.REACT_APP_HOME} />;
    } else {
      return <Outlet />;
    }
  }
};

export default AuthenticationElement;
